import { OutdoorType } from 'core/creative/Creative';
import { OutdoorForm } from './OutdoorForm';
import { BasicOutdoorFormModel, OutdoorFormProps } from './OutdoorFormModel';
import { BeaconType } from 'core/advertiser/BeaconConnection';
import i18n from 'i18n';

export class LineMessageFormModel extends BasicOutdoorFormModel<LineMessageFormModel> {
  override get channelName() {
    return 'Matsukiyo';
  }

  override get useMediaDuration() {
    return true;
  }

  override get neglectedFormFields(): string[] {
    return [
      'typeProperties.creativeSize',
      'typeProperties.outdoorType',
      'medias.video',
      'typeProperties.duration'
    ];
  }

  override getFormContent(): (
    props: OutdoorFormProps<LineMessageFormModel>
  ) => JSX.Element {
    return OutdoorForm<LineMessageFormModel>;
  }

  override getDefaultDuration = () => {
    return 1;
  };

  override getInitTypeProperties() {
    return {
      ...super.getInitTypeProperties(),
      creativeSize: '1920 x 1080' as `${number} x ${number}`,
      outdoorType: OutdoorType.VIDEO,
      useAudio: false
    };
  }

  override get initBeaconSwitch() {
    return true;
  }

  override get beaconTypeOptions(): SelectOptions[] {
    return [
      {
        label: i18n.t('beaconType.lineSimpleBeacon'),
        value: BeaconType.LINE_SIMPLE_BEACON
      }
    ];
  }
}
